var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (location) {
buf.push("<div class=\"location\"><a" + (jade.attr("href", location.googleMapsLink(), true, true)) + " target=\"_blank\"><img" + (jade.attr("src", location.mapImageSrc(740, 230), true, true)) + " class=\"map\"></a><p class=\"location-details\">" + (null == (jade_interp = location.toHtml()) ? "" : jade_interp) + "</p></div>");}.call(this,"location" in locals_for_with?locals_for_with.location:typeof location!=="undefined"?location:undefined));;return buf.join("");
};
module.exports = template;